import React from 'react';
// styles
import {
  InputStyled,
  LabelStyled,
  LabelTextStyled,
} from './styles';

// eslint-disable-next-line import/prefer-default-export
export default ({
  children,
  className,
  id,
  label,
  onChange,
  placeholder,
  value,
  ...rest
}) => {
  return (
    <LabelStyled>
      <LabelTextStyled>{label}</LabelTextStyled>
      <InputStyled
        className={className}
        id={id}
        onChange={onChange}
        placeholder={placeholder}
        type='text'
        value={value}
        {...rest}
      />
      {children}
    </LabelStyled>
  );
};
